export default "__VITE_ASSET__BujhJXEJ__"